/** Bridge: POS checkout completes a work order sale (full / seña / saldo). */

import type { WorkOrderPaymentKind } from '../domain/types';

export type PendingWorkOrderCheckout = {
  workOrderId: string;
  /** Product IDs de las tareas (servicios) — para validar que el carrito las incluye. */
  taskProductIds: string[];
  /** Product IDs de los repuestos — para validar que el carrito las incluye. */
  partProductIds: string[];
  kind: WorkOrderPaymentKind;
  /** Monto a cobrar en seña/saldo (custom line). Null = usar ítems de la OT. */
  amountDue: number | null;
  otLabel: string;
};

let pending: PendingWorkOrderCheckout | null = null;

export function setPendingWorkOrderCheckout(
  workOrderId: string | null,
  taskProductIds?: string[] | null,
  partProductIds?: string[] | null,
  opts?: {
    kind?: WorkOrderPaymentKind;
    amountDue?: number | null;
    otLabel?: string;
  },
): void {
  if (!workOrderId) {
    pending = null;
    return;
  }
  pending = {
    workOrderId,
    taskProductIds: taskProductIds ?? [],
    partProductIds: partProductIds ?? [],
    kind: opts?.kind ?? 'full',
    amountDue: opts?.amountDue ?? null,
    otLabel: opts?.otLabel ?? 'OT',
  };
}

export function peekPendingWorkOrderCheckout(): PendingWorkOrderCheckout | null {
  return pending;
}

export function takePendingWorkOrderCheckout(): PendingWorkOrderCheckout | null {
  const value = pending;
  pending = null;
  return value;
}
